import { Editor } from "@ckeditor/ckeditor5-core";
import { EditorConfig } from "@ckeditor/ckeditor5-core/src/editor/editorconfig";
import {
  FileLoader,
  UploadAdapter,
} from "@ckeditor/ckeditor5-upload/src/filerepository";
import { CMSUploadConfig } from "./agumentation";

export function CMSUploadAdapterPlugin(editor: Editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = (
    loader: FileLoader
  ) => {
    return new CMSUploadAdapter(loader, editor.config.get("cmsUpload") as any);
  };
}

class CMSUploadAdapter implements UploadAdapter {
  private loader: any;
  private uploadUrl: string | URL;
  private debugMode: boolean = false;

  constructor(loader: FileLoader, config: CMSUploadConfig) {
    this.loader = loader;
    this.uploadUrl = config.uploadUrl;
    this.debugMode = config.debug;
  }

  upload() {
    return this.loader.file.then(
      (file: File) =>
        new Promise((resolve, reject) => {
          const data = new FormData();
          data.append("upload", file);

          fetch(this.uploadUrl, {
            method: "POST",
            body: data,
          })
            .then((response) => response.json())
            .then((result) => {
              resolve({
                default: result.url,
              });
            })
            .catch((error) => {
              reject(error);
            });
        })
    );
  }

  abort() {
    // 중단 처리
  }
}
